import axios from 'axios';
import Layout from '../shared/Layout';
import { useEffect, useState } from 'react';
import language from '../../variables/language';
import { Link, useParams } from 'react-router-dom';
import Header from '../shared/Header';
import { Infopanel } from './Infopanel';
import MessagesTimeline from './MessagesTimeline';
import IconSchema from '../../components/icons/IconSchema';
import '../../css/questions.css';
import '../../css/messages-timeline.css';

const Messages = () => {
  const label = 'messages';
  const { id } = useParams();

  const [conversatioProgress, setConversationProgress] = useState();

  useEffect(() => {
    getConversation(id);
  }, [id]);

  const getConversation = (conversationProgressId) => {
    let url = '/api/conversationprogress/' + conversationProgressId
    axios.get(url, { withCredentials: true })
      .then(response => setConversationProgress(response.data))
      .catch(error => console.error(error));
  }

  return (
    <Layout>
      <Header
        name={
          <>
            {language[language.lang][label]}
            {conversatioProgress?.conversationId ? (
              <Link
                to={'/conversations-creator-canvas/' + conversatioProgress.conversationId.id}
                className='header-template-link'
                title='Перейти до шаблону конверсації'
              >
                <IconSchema fillColor='icon-contrast' style={{ height: 16, width: 16, margin: 0 }} />
                <span>{conversatioProgress.conversationId.name}</span>
              </Link>
            ) : ''}
          </>
        }
        opened='300px'
      >
      </Header>
      <main className='main-block'>
        <div className='main-content txt-c'>
          <Infopanel url={'/api/messages/byfunction/' + id}></Infopanel>
          {conversatioProgress ? (
            <MessagesTimeline
              conversationProgressId={id}
              conversation={conversatioProgress.conversationId}
              outerUserId={conversatioProgress.outerUserId?.id}
            />
          ) : ''}
        </div>
      </main>
    </Layout>
  )
}

export default Messages
